const theme = {
	borderStyle: '1px solid #3e3e3e'
}

export default theme